import { Injectable } from '@angular/core';
import { getSvgMarker } from 'src/app/helpers/utils';

export interface MarkerIconConfig {
  icon: string;
  width: number;
  height: number;
}

@Injectable({
  providedIn: 'root'
})
export class MarkerIconService {
  private readonly ICON_CONFIGS: { [key: string]: MarkerIconConfig } = {
    particulier: {
      icon: '/assets/icon/house.svg',
      width: 35,
      height: 66
    },
    prestataire: {
      icon: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(getSvgMarker("")),
      width: 42,
      height: 81
    },
    point_of_arrival: {
      icon: '/assets/icon/map-icons/icone_destination.svg',
      width: 32,
      height: 53
    },
    starting_point: {
      icon: '/assets/icon/map-icons/icone_pickup.svg',
      width: 32,
      height: 53
    }
  };

  private readonly DEFAULT_ICON: MarkerIconConfig = {
    icon: '/assets/icon/map-icons/location-pin-black.png',
    width: 48,
    height: 80
  };

  getMarkerIcon(type: string, time = ""): MarkerIconConfig {
    if (time && type == "prestataire") {
      return {
        icon: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(getSvgMarker(time)),
        width: 42,
        height: 81
      }
    }
    return this.ICON_CONFIGS[type] || this.DEFAULT_ICON;
  }

  getGoogleMapsIcon(type: string): any {
    const config = this.getMarkerIcon(type);
    return {
      url: config.icon,
      scaledSize: new google.maps.Size(config.width, config.height),
      anchor: new google.maps.Point(config.width / 2, config.height / 2)
    };
  }

  getLeafletIcon(type: string, time = ""): any {
    const config = this.getMarkerIcon(type, time);


    // All icons anchor at bottom-center for consistent positioning
    // iconAnchor: [width/2, height] means center horizontally, bottom vertically
    // This ensures the bottom of the icon aligns with the coordinate
    const iconAnchor: [number, number] = [
      Math.round(config.width / 2),
      Math.round(config.height)
    ];
    const popupAnchor: [number, number] = [
      0,
      -Math.round(config.height)
    ];

    return {
      iconUrl: config.icon,
      iconSize: [config.width, config.height],
      // iconAnchor: iconAnchor,
      // popupAnchor: popupAnchor
    };
  }

  /**
   * Get MapKit icon anchor point based on icon type
   * anchorOffset in MapKit is relative to the top-left corner of the image
   * For icons with pointed bottom (house, pins), anchor should be at bottom-center
   * For horizontal icons (car), anchor should be at center
   */
  getMapKitIconAnchor(type: string): { x: number; y: number } {
    const config = this.getMarkerIcon(type);

    // Icons with pointed bottom should anchor at bottom-center
    // anchorOffset: (width/2, height) means center horizontally, bottom vertically
    const bottomAnchoredTypes = ['particulier', 'point_of_arrival', 'starting_point'];
    if (bottomAnchoredTypes.includes(type)) {
      return {
        x: config.width / 2,
        y: config.height / 2
      };
    }

    // Horizontal icons (like car) anchor at center
    // anchorOffset: (width/2, height/2) means center both horizontally and vertically
    return {
      x: config.width / 2,
      y: config.height / 2
    };
  }

  getAllIconTypes(): string[] {
    return Object.keys(this.ICON_CONFIGS);
  }

  isValidIconType(type: string): boolean {
    return type in this.ICON_CONFIGS;
  }

} 